import { getCookieConsentValue } from 'react-cookie-consent';
import { AppStatusInterface } from '../store/types';

export type CookiesConsent = AppStatusInterface['cookiesConsent'];

/**
 * The customer's answer on the cookie banner, read from the consent cookie that react-cookie-consent writes
 * (components-library/CookieConsent) — the source of truth. `appStatus.cookiesConsent` is a copy of it that
 * redux-persist keeps in localStorage, so it can outlive the cookie: the cookie's 365-day expiry, cookies
 * cleared on their own, an answer given in another tab. Decide consent from this, never from the copy alone.
 * Anything but 'true' / 'false' is no answer.
 */
export function readCookieConsent(): CookiesConsent {
  const value = getCookieConsentValue();

  return value === 'true' || value === 'false' ? value : undefined;
}

/**
 * Whether analytics may run: an explicit accept on the cookie banner, or the native app's WebView. The apps
 * never render the banner (it lives on RestaurantDetailsScreen only), so gating them on it would leave every
 * app user untracked; the apps are tracked as before. Session replay is not covered by this and still needs
 * the banner's accept.
 */
export function hasTrackingConsent(consent: CookiesConsent, isMobileApp: boolean): boolean {
  return isMobileApp || consent === 'true';
}
